import { bus_monitoring } from '../../models/response/bus/bus_monitoring';
import { apiClient } from '../apiClient';
import { BaseCRUDApi } from '../baseCRUDApi';

export const API_BUS_MONITORING_PATH = "bus/monitoring";

class BusMonitoringApi extends BaseCRUDApi<bus_monitoring> {
	// eslint-disable-next-line @typescript-eslint/no-useless-constructor
	constructor(path: string) {
		super(path);
	}
	SelectByCoSo(dm_coso_id: number) {
		return apiClient.get(`co-so/${dm_coso_id}/bus/monitoring`);
	}
}
export const busMonitoringApi = new BusMonitoringApi(API_BUS_MONITORING_PATH);
